<script>
import {useThemeStore} from "@js/store/ThemeStore.js";
import {checkDocument} from "@js/helpers.ts";

export default {
    name: "IconShare",
    methods: {
        share() {
            if (!checkDocument() && typeof navigator.share !== 'undefined') {
                navigator.share({
                    title: this.$page.props.title,
                    text: this.$page.props.description,
                    url: window.location.href
                })
            } else {
                this.copy()
            }
        },
        async copy() {
            try {
                await navigator.clipboard.writeText(window.location.href);

                const themeStore = useThemeStore();
                themeStore.addToast("Ссылка скопирована", "success");
            } catch (err) {
                console.error("Не удалось скопировать ссылку:", err);
            }
        }
    },
}
</script>

<template>
    <svg @click.prevent="share" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 18 18">
        <path
            d="M14.419 10.581a3.564 3.564 0 0 0-2.574 1.1l-4.756-2.49a3.54 3.54 0 0 0 .072-.71 3.55 3.55 0 0 0-.043-.428L11.67 6.1a3.56 3.56 0 1 0-.831-2.265c.006.143.02.286.043.428L6.33 6.218a3.573 3.573 0 1 0-.175 4.743l4.756 2.491a3.58 3.58 0 1 0 3.508-2.871Z"/>
    </svg>
</template>

<style scoped lang="scss">

</style>
